import { globalTheme } from 'srs.sharedcomponents/lib/esm/styles/config'

const themeColor = '#002469'
const fontColor = '#ffff'
export const customTheme = {
  ...globalTheme,
  colors: {
    ...globalTheme.colors,
    primary: themeColor,
    topNavigation: fontColor,
    logoutButton: fontColor,
    menuButton: themeColor,
    hoverMenuButton: themeColor,
    hoverMenuButtonMobile: themeColor,
    topNavigationMobile: themeColor,
  },
}
